import AddToInventoryIcon from './AddToInventoryIcon';

export default AddToInventoryIcon;
